import merge from 'lodash/merge'

const selectors = {
  base: '[type="json/options"]'
}

let globalOptions = {}

const parseScriptTags = (scriptElements) => [...scriptElements]
  .reduce((accumulator, scriptElement ) => {
    const payload = scriptElement.innerHTML
    if(typeof payload === 'string') {
      try {
        return merge(accumulator, JSON.parse(payload))
      } catch (error) {
        console.error(`Could not parse script tag with payload: ${payload}`, error)
        return accumulator
      }
    }
    return accumulator
  }, {})

export const queryPageOptions = () => parseScriptTags(document.querySelectorAll(selectors.base))

const get = propertyName => globalOptions[propertyName]

globalOptions = queryPageOptions()

export { get }